import {
  type CommandProperties,
  createCommand,
} from '@atlassian/rovo-content-bridge-api';

/**
 * @see {@link DiscardDraftChangesCommand}
 */
export type DiscardDraftChangesCommandProperties = CommandProperties;

/**
 * Command to discard draft changes in the database native embed experience.
 *
 * This command discards any pending changes made to database content,
 * allowing users to abandon their work without affecting the persisted data.
 *
 * The intention is that that this mimics the "Discard changes" banner.
 */
export const DiscardDraftChangesCommand = createCommand<
  DiscardDraftChangesCommandProperties,
  void
>('discard-draft-changes-command');
